import React from 'react';

import classnames from 'classnames';

import styles from './styles/star-rating-star.css';

interface StarRatingStarProps {
  className?: string;
  type?: string;
  rating?: string;
}

const StarRatingStar: React.FC<StarRatingStarProps> = ({ className, type, rating }) => {
  // Useful reference http://jsfiddle.net/M8UAy/
  // This requires the star character as span text content
  return (
    <span
      className={classnames(styles.container, className && styles[className])}
      data-type={type}
      data-rating={rating}
    >
      ☆
    </span>
  );
};

export default StarRatingStar;
